import { createPlatformReadService } from '../application/createPlatformReadService';
import { supabasePlatformReadPort } from '../infrastructure/supabasePlatformReadPort';

export const platformReadService = createPlatformReadService(supabasePlatformReadPort);
